<template>
  <div class="forgotPassword-page">
    <div class="forgotPassword-content">
      <div class="header">
        <div class="header-title">
          <img width="48px" height="48px" src="../assets/isa_app_logo.png" />
          <dl class="pt">
            <dt> {{ appInfo.name || '系统' }}</dt>
            <dd>System Name</dd>
          </dl>
        </div>
        <span class="header-text">找回密码</span>
      </div>
      <div class="close-btn" @click="goBack">
        <img width="30px" height="30px" src="../assets/isa_close.png" />
      </div>
      <div class="content-container">
        <a-spin :spinning="loading">
              <div class="box" v-if="isTenant">
                <p class="box-title">企业域</p>
                <a-input placeholder="请输入企业域"
                         size="large"
                         v-model="forgetPassword.tenant"
                         @input="handleTenantInput">
                </a-input>
              </div>
              <div class="box">
                <p class="box-title">手机号</p>
                <a-input placeholder="请输入手机号"
                  size="large"
                  v-model="forgetPassword.phone">
                </a-input>
              </div>
              <div class="box" style="overflow:hidden;">
                <p class="box-title">验证码</p>
                <a-input style="float:left;width:50%;" placeholder="请输入验证码"
                         size="large"
                         v-model="forgetPassword.code">
                </a-input>
                <a-button type="link" style="float:right;margin-top: 5px;" :disabled="resetPwdTimer > 0 && resetPwdTimer !== 60" @click="sendResetCode">
                  {{ (resetPwdTimer === 0 || resetPwdTimer === 60) ? '获取验证码' : '重新发送(' + resetPwdTimer + ')' }}
                </a-button>
              </div>
              <div class="box">
                <p class="box-title">新密码</p>
                <a-input-password placeholder="请输入新密码"
                                  size="large"
                                  type="password"
                                  v-model="forgetPassword.newPassword">
                </a-input-password>
              </div>
              <div class="box">
                <p class="box-title">确认密码</p>
                <a-input-password placeholder="请输入确认密码"
                                  size="large"
                                  type="password"
                                  v-model="forgetPassword.confirmPassword">
                </a-input-password>
              </div>
              <div style="margin-top: 25px;">
                <a-button style="width: 100%;"
                          type="primary"
                          size="large"
                          @click="resetPassword">
                  确认重置
                </a-button>
              </div>
              <div style="margin-top: 25px; text-align: center;" v-if="errorMsg">
                  <span style="text-align: center; color: #e75353; font-size: 14px; ">
                    {{ errorMsg }}
                  </span>
              </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      errorMsg: state => state.login.data.errorMsg,
      error: state => state.login.data.error,
      loading: state => state.login.data.loading,
      forgetPassword: state => state.login.forgetPassword,
      appInfo: state => state.login.data.appInfo,
      isTenant: state => state.login.data.isTenant,
      resetPwdTimer: state => state.login.data.resetPwdTimer,
    }),
  },

  created() {
    this.$store.dispatch('init');
    this.$store.dispatch('getAppInfo');
  },

  methods: {
    goBack() {
      // 获取当前URL的query参数
      const query = this.$route.query;
      // 返回登录页面，带上完整的query参数
      this.$router.push({
        path: '/isaLogin',
        query: query
      });
    },

    sendResetCode() {
      this.$store.dispatch('sendResetCode', this).then(() => {
        this.$store.dispatch('triggerCaptcha').then((res) => {
          if (res) {
            this.$store.dispatch('getCaptcha');
          }
        });
      });
    },

    resetPassword() {
      this.$store.dispatch('resetPassword', this).then(() => {
        // 获取当前URL的query参数
        const query = this.$route.query;
        // 返回登录页面，带上完整的query参数
        this.$router.push({
          path: '/isaLogin',
          query: query
        });
      });
    },

    handleTenantInput() {
      if (this.forgetPassword.tenant) {
        this.$store.state.login.forgetPassword.tenant = this.forgetPassword.tenant.toUpperCase();
      }
    },
  }
};
</script>

<style lang="less" scoped>
.forgotPassword-page {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-image: url('../assets/isa_bg.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.forgotPassword-content {
  background-color: #fffc;
  border-radius: 10px;
  width: 550px;
  height: 720px;
  margin-top: 5%;
  box-shadow: -15px 15px 99px 0px rgba(48,66,84,0.15);
  padding: 73px 67px 0;
  position: relative;
}
.content-container {
  margin-top: 37px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-title {
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: #273250;
  img{
    vertical-align: middle;
    margin-right: 8px;
  }
  dl{
    margin:0;
    dt{
      margin:0;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #273250;
      font-weight: 600;
    }
    dd{
      margin:0;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #273250;
      font-weight: 400;
    }
  }
  .pt{
    margin-right: 20px;
  }
}
.header-text {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #273250;
  font-weight: 600;
}
.close-btn {
  cursor: pointer;
  display: inline-block;
  position: absolute;
  top: 20px;
  right: 20px;
}
::v-deep .ant-input:placeholder-shown,::v-deep input[type='text'],::v-deep .ant-input-affix-wrapper .ant-input{
  border: none !important;
}
::v-deep .ant-input:focus{
 box-shadow: none;
}
.box{
  margin-bottom: 20px;
  border: 1px solid #C9CDD4;
  padding-top: 10px;
  border-radius: 4px;
  background-color: #fff;
  .box-title {
    margin:0;
    padding-left: 10px;
    font-family: PingFangSC-Semibold;
    font-size: 12px;
    color: #4E5969;
    font-weight: 600;
  }
  .ant-input ant-input-lg{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #1D2129;
    font-weight: 400;
  }
}
::v-deep .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled),::v-deep .ant-input:hover{
  border:none;
}
::v-deep :focus-visible,.ant-input{
    outline: none;
}
::v-deep .ant-btn-primary {
  background-color: #273250;
  border-color: #273250;
}
::v-deep .ant-btn-link {
  color: #165DFF;
}
</style>
